import { UpdateDocument, UpdateDocumentToken } from "$src/application/projects/sub/documents/commands/UpdateDocument";
import { DocumentIdentifier } from "$src/domain/projects/documents/DocumentIdentifier";
import { DocumentMeta } from "$src/domain/projects/documents/DocumentMeta";
import { ProjectionGenerator } from "$src/infrastructure/designs/core/edge-projection";
import { useMutation, useQueryClient } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

export async function updateDocument(groupStoreId: number, projectId: number, documentId: string, meta: DocumentMeta)
    : Promise<DocumentIdentifier> {

    const query = container.resolve<UpdateDocument>(UpdateDocumentToken);
    return query.execute(groupStoreId, projectId, documentId, meta);
}

export function useUpdateDocument() {
    const queryClient = useQueryClient();

    return useMutation(
        ({ groupStoreId, projectId, documentId, meta }: 
            { groupStoreId: number, projectId: number, documentId: string, meta: DocumentMeta }
        ) => updateDocument(groupStoreId, projectId, documentId, meta),
        {
            onSuccess: (data, variables) => {
                // const { groupStoreId, projectId, documentId } = variables;
                // queryClient.invalidateQueries(['documents', groupStoreId, projectId]);
                // queryClient.invalidateQueries(['document', groupStoreId, projectId, documentId]);
                queryClient.invalidateQueries(['documents']);
                queryClient.invalidateQueries(['document']);
            },
            onError: (error: Error) => {
                console.error('Failed to update document:', error);
            },
            onSettled: () => {
            },
        }
    );
}